import React from 'react';
import { Box, Chip, Tab, Tabs } from '@mui/material';
import type { ParticipantTab } from '../../interfaces';
import { PARTICIPANT_TABS } from '../constants';

export interface ITabCountMap {
  applications?: number;
  assessments?: number;
  interviews?: number;
  wellness?: number;
}

export interface IParticipantTabsNavProps {
  activeTab: ParticipantTab;
  onChange: (tab: ParticipantTab) => void;
  counts?: ITabCountMap;
}

/** Segmented tab list built with MUI Tabs and Tab components. */
export const ParticipantTabsNav = ({ activeTab, onChange, counts }: IParticipantTabsNavProps) => {
  return (
    <Box sx={{ width: 'fit-content', maxWidth: '100%', overflowX: 'auto' }}>
      <Tabs
        value={activeTab}
        onChange={(_, value: ParticipantTab) => onChange(value)}
        aria-label="Candidate sections"
        variant="scrollable"
        scrollButtons="auto"
      >
        {PARTICIPANT_TABS.map((tab) => {
          const Icon = tab.icon;
          const count = counts?.[tab.id as keyof ITabCountMap];
          const isActive = activeTab === tab.id;

          return (
            <Tab
              key={tab.id}
              value={tab.id}
              id={`participant-tab-${tab.id}`}
              aria-controls={`participant-tabpanel-${tab.id}`}
              icon={<Icon size={16} />}
              iconPosition="start"
              label={
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                  <span>{tab.label}</span>
                  {typeof count === 'number' && (
                    <Chip
                      label={count}
                      size="small"
                      sx={{
                        height: 18,
                        fontSize: '0.68rem',
                        fontWeight: 700,
                        bgcolor: isActive ? 'rgba(5, 150, 105, 0.1)' : 'grey.200',
                        color: isActive ? '#059669' : 'text.secondary',
                        border: 'none',
                        '& .MuiChip-label': { px: 0.75 },
                      }}
                    />
                  )}
                </Box>
              }
            />
          );
        })}
      </Tabs>
    </Box>
  );
};
